<template>
  <div class="col table-responsive">
    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th scope="col" class="multi-line-header">Produktionsdatum</th>
          <th scope="col" class="multi-line-header">Operator</th>
          <th scope="col" class="multi-line-header">Charge-Nr Komponente</th>
          <th scope="col" class="multi-line-header">A oder B-Komponente</th>
          <th scope="col" class="multi-line-header">
            Produktionsdatum Komponente
          </th>
          <th scope="col" class="multi-line-header">Wareneingang?</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(entry, tableId) in entries" :key="tableId">
          <td>{{ entry.dateInProduction.replace("T", " ") }}</td>

          <td>{{ entry.username }}</td>

          <td>{{ entry.pottingBatch }}</td>

          <td>{{ entry.component }}</td>

          <td v-if="checkDate(entry.dateInProduction, entry.manufacturingDate)">
            {{ entry.manufacturingDate.split("T")[0] }}
          </td>
          <td class="expired" v-else>
            {{ entry.manufacturingDate.split("T")[0] }}
          </td>

          <td v-if="entry.isGoodEntrance">Ja</td>
          <td v-else>Nein</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import { ref, defineProps, onMounted } from "vue";
import { instance as axios } from "@/services/axios";

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
});

const entries = ref([]);

const checkDate = (dateInProduction, manufacturingDate) => {
  const oneDay = 24 * 60 * 60 * 1000;
  const eightMonths = oneDay * 30 * 8;

  const diff = Date.parse(dateInProduction) - Date.parse(manufacturingDate);

  return diff < eightMonths;
};

const fetchData = async (url) => {
  try {
    const { data } = await axios.get(url);
    entries.value = data;
  } catch (error) {
    if (error.response) {
      console.log(`HTTP error! Status: ${error.response.status}`);
    } else {
      console.log("Netzwerkproblem:", error.message);
    }
  }
};

onMounted(() => {
  fetchData(props.url);
});
</script>

<style scoped>
@media (max-width: 768px) {
  th {
    white-space: normal;
    word-wrap: break-word;
  }
}

.expired {
  color: darkorange !important;
}
</style>
